import React, { useState, useEffect, useMemo } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import DoctoresService from "../services/DoctoresService";
import ListasPreciosService from "../services/ListasPreciosService";
import EstudiosService from "../services/EstudiosService";
import PreciosEstudioService from "../services/PreciosEstudioService";
import Icon from "@mdi/react";
import { mdiFileExcel } from "@mdi/js";

import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Checkbox,
  Tooltip,
  tooltipClasses,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const ListasPrecios = () => {
  const [highlighted, setHighlighted] = useState({});
  useEffect(() => {
    document.title = "Listas de precios";
  }, []);
  const MySwal = withReactContent(Swal);
  function mostrarMensaje(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
  function mostrarMensajeLista(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.close();
      }
    });
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  function reloadPage() {
    window.location.reload();
  }

  const [viewOnly, setViewOnly] = useState(false);
  const [estudios, setEstudios] = useState([]);
  const [listas, setListas] = useState([]);
  const [selectedListas, setSelectedListas] = useState([]);
  const [preciosByLista, setPreciosByLista] = useState({});
  const [estudioBuscar, setEstudioBuscar] = useState("");
  const [ordenarEstudios, setOrdenarEstudios] = useState("alfabeticamente");
  const [mostrarSubrogados, setMostrarSubrogados] = useState(true);
  const [mostrarNoSubrogados, setMostrarNoSubrogados] = useState(true);
  const [redondearPrecios, setRedondearPrecios] = useState("si");
  const [bulkAction, setBulkAction] = useState("seleccione");
  const [bulkAmount, setBulkAmount] = useState("");
  const [bulkType, setBulkType] = useState("seleccione");
  const [bulkSubrogados, setBulkSubrogados] = useState(true);
  const [bulkNoSubrogados, setBulkNoSubrogados] = useState(true);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  useEffect(() => {
    async function initData() {
      setLoading(true);
      try {
        await Promise.all([
          fetchListas(),
          fetchEstudios(),
          fetchPrecios()
        ]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    initData();
  }, []);

  async function fetchListas() {
    try {
      const resultado = await ListasPreciosService.getListas();
      const data = resultado.data.listas;
      setListas(data);
      setSelectedListas(data.map((lista) => lista.idListaPrecio));
    } catch (err) {
      console.error(err);
    }
  }

  function toggleSelectedLista(idLista) {
    setSelectedListas((prev) =>
      prev.includes(idLista)
        ? prev.filter((selected) => selected !== idLista)
        : [...prev, idLista],
    );
  }

  const activeListas = useMemo(() => {
    return listas.filter((lista) =>
      selectedListas.includes(lista.idListaPrecio),
    );
  }, [listas, selectedListas]);

  const estudiosFiltrados = useMemo(() => {
    return estudios.filter((estudio) => {
      const matchSubrogado = estudio.subrogado ? mostrarSubrogados : mostrarNoSubrogados;
      if (!matchSubrogado) return false;

      if (estudioBuscar.trim() !== "") {
        const q = estudioBuscar.toLowerCase().trim();
        const matchName = estudio.nombre?.toLowerCase().includes(q);
        const matchCode = estudio.codigo?.toLowerCase().includes(q);
        const matchSinonimo = estudio.sinonimos?.toLowerCase().includes(q);
        return matchName || matchCode || matchSinonimo;
      }
      return true;
    });
  }, [estudios, mostrarSubrogados, mostrarNoSubrogados, estudioBuscar]);

  const estudiosOrdenados = useMemo(() => {
    return [...estudiosFiltrados].sort((a, b) => {
      if (ordenarEstudios === "codigo") {
        return (a.codigo || "").localeCompare(b.codigo || "");
      } else if (ordenarEstudios === "alfabeticamente") {
        return (a.nombre || "").localeCompare(b.nombre || "");
      } else if (ordenarEstudios === "area") {
        const areaA = a.nombreArea || "";
        const areaB = b.nombreArea || "";
        if (areaA !== areaB) {
          return areaA.localeCompare(areaB);
        }
        return (a.nombre || "").localeCompare(b.nombre || "");
      } else if (ordenarEstudios === "subrogados") {
        const subA = a.subrogado ? 1 : 0;
        const subB = b.subrogado ? 1 : 0;
        if (subA !== subB) {
          return subB - subA;
        }
        return (a.nombre || "").localeCompare(b.nombre || "");
      }
      return 0;
    });
  }, [estudiosFiltrados, ordenarEstudios]);

  useEffect(() => {
    setPage(0);
  }, [estudioBuscar, mostrarSubrogados, mostrarNoSubrogados, ordenarEstudios]);

  const estudiosPaginados = useMemo(() => {
    return estudiosOrdenados.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [estudiosOrdenados, page, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function fetchEstudios() {
    try {
      const resultado = await EstudiosService.getEstudios();
      const data = resultado.data.estudios;
      setEstudios(data);
    } catch (err) {
      console.error(err);
    }
  }

  async function fetchPrecios() {
    try {
      const resultado = await PreciosEstudioService.getPrecios();
      const data = resultado.data.precios;
      const map = {};
      (data || []).forEach((p) => {
        if (!map[p.idListaPrecio]) map[p.idListaPrecio] = {};
        map[p.idListaPrecio][p.idEstudio] = p.precio;
      });
      setPreciosByLista(map);
    } catch (err) {
      console.error(err);
    }
  }

  async function handleSavePrecio(idLista, idEstudio, value) {
    try {
      let finalVal = value;
      if (redondearPrecios === "si" && value !== "") {
        const num = parseFloat(value);
        if (!isNaN(num)) {
          finalVal = Math.round(num).toString();
        }
      }
      const body = { "idListaN": idLista, "idEstudioN": idEstudio, "precioN": finalVal };
      const resultado = await PreciosEstudioService.savePrecio(body);
      if (resultado.data && resultado.data.estatus === "OK") {
        const savedPrecio =
          resultado.data.precio !== undefined ? resultado.data.precio : finalVal;
        setPreciosByLista((prev) => {
          const next = { ...prev };
          if (!next[idLista]) next[idLista] = {};
          next[idLista][idEstudio] = savedPrecio;
          return next;
        });
        setHighlighted((prev) => ({
          ...prev,
          [`${idLista}-${idEstudio}`]: true,
        }));
      } else {
        mostrarError(resultado.data?.mensaje || "No se pudo guardar el precio");
      }
    } catch (err) {
      console.error(err);
      mostrarError("No se pudo guardar el precio");
    }
  }

  async function handleDeleteLista(idLista) {
    Swal.fire({
      title: "¿Eliminar lista?",
      text: `¿Desea eliminar la lista?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const resultado = await ListasPreciosService.deleteLista(idLista);
          if (resultado.data && resultado.data.estatus === "OK") {
            setListas((prev) => prev.filter((l) => l.idListaPrecio !== idLista));
            setSelectedListas((prev) => prev.filter((selected) => selected !== idLista));
            setPreciosByLista((prev) => {
              const next = { ...prev };
              delete next[idLista];
              return next;
            });
            mostrarMensaje("Lista eliminada");
          } else {
            mostrarError(resultado.data?.mensaje || "No se pudo eliminar la lista");
          }
        } catch (err) {
          console.error(err);
          mostrarError("No se pudo eliminar la lista");
        }
      }
    });
  }

  async function handleResetPreciosEstudio(idEstudio, nombreEstudio) {
    Swal.fire({
      title: "¿Eliminar precios del estudio?",
      text: `¿Desea reiniciar a 0 los precios del estudio "${nombreEstudio}" en todas las listas?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, reiniciar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const resultado = await PreciosEstudioService.reiniciarPrecios(idEstudio);
          if (resultado.data && resultado.data.estatus === "OK") {
            setPreciosByLista((prev) => {
              const next = { ...prev };
              Object.keys(next).forEach((idLista) => {
                if (next[idLista]) {
                  next[idLista] = {
                    ...next[idLista],
                    [idEstudio]: "0",
                  };
                }
              });
              return next;
            });
            mostrarMensajeLista("Precios del estudio reiniciados a 0");
          } else {
            mostrarError(resultado.data?.mensaje || "No se pudieron reiniciar los precios");
          }
        } catch (err) {
          console.error(err);
          mostrarError("No se pudieron reiniciar los precios");
        }
      }
    });
  }

  async function handleApplyBulkOperation() {
    Swal.fire({
      title: "¿Aplicar cambios en bloque?",
      text: `Se aplicará un cambio masivo de precios en las listas seleccionadas. ¿Desea continuar?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, aplicar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const targetStudies = estudios.filter((e) => {
            if (e.subrogado && bulkSubrogados) return true;
            if (!e.subrogado && bulkNoSubrogados) return true;
            return false;
          });

          if (targetStudies.length === 0) {
            mostrarError("No hay estudios que coincidan con los criterios seleccionados.");
            return;
          }

          const body = {
            listas: selectedListas,
            estudios: targetStudies.map((e) => e.idEstudio),
            accion: bulkAction,
            tipo: bulkType,
            monto: parseFloat(bulkAmount),
            redondear: redondearPrecios === "si",
          };

          const resultado = await PreciosEstudioService.actualizarPreciosBulk(body);
          if (resultado.data && resultado.data.estatus === "OK") {
            await fetchPrecios();
            setBulkAmount("");
            setBulkAction("seleccione");
            setBulkType("seleccione");
            mostrarMensajeLista("Cambios masivos aplicados correctamente");
          } else {
            mostrarError(resultado.data?.mensaje || "No se pudieron aplicar los cambios masivos");
          }
        } catch (err) {
          console.error(err);
          mostrarError("No se pudieron aplicar los cambios masivos");
        }
      }
    });
  }

  const handleMostrarTodos = () => {
    setEstudioBuscar("");
    setMostrarSubrogados(true);
    setMostrarNoSubrogados(true);
    setOrdenarEstudios("alfabeticamente");
  };

  const handleExportarExcel = () => {
    const fechaActual = new Date().toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });

    let tableHtml = `<table border="1">`;
    tableHtml += `<tr><td colspan="${2 + activeListas.length}" style="font-weight: bold; font-size: 14pt; height: 30px; text-align: center;">Reporte de precios del dia ${fechaActual}</td></tr>`;

    tableHtml += `<tr style="background-color: #e0f2f1; font-weight: bold; text-align: center;">`;
    tableHtml += `<td>Código</td>`;
    tableHtml += `<td>Estudio</td>`;
    activeListas.forEach((l) => {
      tableHtml += `<td>Lista ${l.abreviatura || l.nombre}</td>`;
    });
    tableHtml += `</tr>`;

    estudiosOrdenados.forEach((estudio) => {
      tableHtml += `<tr>`;
      tableHtml += `<td>${estudio.codigo || ""}</td>`;

      let formattedNombre = estudio.nombre || "";
      const esSub = Boolean(estudio.subrogado || estudio.esSubrogado);
      const costoInt = estudio.costoIntPrueba !== undefined ? estudio.costoIntPrueba : estudio.costo_int_prueba;

      if (!esSub && costoInt !== undefined && costoInt !== null && String(costoInt).trim() !== "") {
        formattedNombre += ` ($${costoInt})`;
      }

      if (esSub) {
        formattedNombre += "<b>(subrogado)</b>";
        if (estudio.tipoMuestra) {
          formattedNombre += `<b>(${estudio.tipoMuestra})</b>`;
        }
        formattedNombre += `\n---> ${estudio.laboratorioAbreviatura || ""} ($${estudio.precioSubrogado || 0})`;
      } else {
        if (estudio.tipoMuestra) {
          formattedNombre += `<b>(${estudio.tipoMuestra})</b>`;
        }
      }
      const nameCell = formattedNombre.replace(/\n/g, "<br/>");
      tableHtml += `<td style="white-space: pre-wrap; vertical-align: top;">${nameCell}</td>`;

      activeListas.forEach((l) => {
        const precioVal = (preciosByLista[l.idListaPrecio] && preciosByLista[l.idListaPrecio][estudio.idEstudio] !== undefined)
          ? preciosByLista[l.idListaPrecio][estudio.idEstudio]
          : 0;
        tableHtml += `<td style="text-align: right; vertical-align: top;">${precioVal}</td>`;
      });
      tableHtml += `</tr>`;
    });

    tableHtml += `</table>`;

    const excelFile = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
      <meta charset="utf-8" />
      <!--[if gte mso 9]>
      <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Precios</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
      </xml>
      <![endif]-->
      <style>
        br { mso-data-placement:same-cell; }
      </style>
      </head>
      <body>
        ${tableHtml}
      </body>
      </html>
    `;

    const blob = new Blob([excelFile], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Reporte_Precios_${new Date().toISOString().slice(0, 10)}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  async function handleCrearNuevaLista() {
    const { value: listaNueva } = await MySwal.fire({
      title: "AGREGAR LISTA",
      width: "60%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
        confirmButton: "btnConfirmBlue",
      },
      html: `
        <div style="display:flex;flex-direction:column;gap:1vw;text-align:left;">
          <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">LISTAS DE PRECIOS</div>
          <div style="display:flex;gap:1vw;flex-wrap:wrap;justify-content:space-between;margin-bottom:0.5vw;">
            <div style="display:flex;flex-direction:column;gap:0.25vw;flex:1 1 30%;min-width:160px;">
              <label for="swal-nombre" style="font-weight:700;font-size:0.95vw;">Nombre:</label>
              <input id="swal-nombre" class="input-swal" placeholder="" />
            </div>
            <div style="display:flex;flex-direction:column;gap:0.25vw;flex:1 1 30%;min-width:160px;">
              <label for="swal-abreviatura" style="font-weight:700;font-size:0.95vw;">Abreviatura:</label>
              <input id="swal-abreviatura" class="input-swal" placeholder="" />
            </div>
            <div style="display:flex;flex-direction:column;gap:0.25vw;flex:1 1 30%;min-width:160px;">
              <label for="swal-descripcion" style="font-weight:700;font-size:0.95vw;">Descripción:</label>
              <input id="swal-descripcion" class="input-swal" placeholder="" />
            </div>
          </div>
          <div class="tituloDegradado" style="font-size:0.95vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">ACCIONES SOBRE LA NUEVA LISTA</div>
          <div style="display:flex;flex-direction:column;gap:0.5vw; align-items:center;">
            <label for="swal-duplicar" style="font-weight:700;font-size:0.95vw;">Duplicar lista</label>
            <select id="swal-duplicar" class="swal-duplicar" style="width:20vw;padding:0.7vw 0.8vw;font-size:0.95vw;">
              <option value="">No duplicar</option>
              ${listas
          .map(
            (lista) =>
              `<option value="${lista.idListaPrecio}">${lista.nombre}${lista.abreviatura ? ` (${lista.abreviatura})` : ""}</option>`,
          )
          .join("")}
            </select>
          </div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: (
        <span style={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
          <SaveIcon sx={{ color: "white" }} />
          Crear lista
        </span>
      ),
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const nombre = document.getElementById("swal-nombre")?.value?.trim();
        const abreviatura = document
          .getElementById("swal-abreviatura")
          ?.value?.trim();
        const descripcion = document
          .getElementById("swal-descripcion")
          ?.value?.trim();
        const duplicar = document.getElementById("swal-duplicar")?.value;
        if (!nombre || !abreviatura) {
          Swal.showValidationMessage(
            "El nombre y la abreviatura son obligatorios",
          );
          return false;
        }
        return { nombre, abreviatura, descripcion, duplicar };
      },
    });

    if (listaNueva) {
      try {
        const resultado = await ListasPreciosService.agregarLista(listaNueva);
        if (resultado.data && resultado.data.estatus === "OK") {
          fetchListas();
          fetchPrecios();
          mostrarMensajeLista("Lista creada correctamente");
        } else {
          mostrarError(resultado.data?.mensaje || "No se pudo crear la lista");
        }
      } catch (err) {
        console.error(err);
        mostrarError("No se pudo crear la lista");
      }
    }
  }

  async function handleDeleteEstudio(idEstudio) {
    try {
      const resultado = await EstudiosService.deleteEstudio(idEstudio);
      if (resultado.data && resultado.data.estatus === "OK") {
        setEstudios((prev) => prev.filter((e) => e.idEstudio !== idEstudio));
        mostrarMensaje("Estudio eliminado");
      } else {
        mostrarError(
          resultado.data?.mensaje || "No se pudo eliminar el estudio",
        );
      }
    } catch (err) {
      console.error(err);
      mostrarError("No se pudo eliminar el estudio");
    }
  }

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            width: "100vw",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperListaP"
            >
              <Typography
                variant="h7"
                fontWeight="bold"
                gutterBottom
                sx={{
                  background: "linear-gradient(90deg, #006787, #014e65)",
                  color: "white",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  display: "inline-block",
                  fontWeight: "bold"
                }}
              >
                LISTAS DE PRECIOS
              </Typography>

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{ paddingTop: "0.4vw" }}
                >
                  <Stack direction="row" spacing={"0.2vw"} alignItems="flex-start">
                    <Box
                      sx={{
                        borderRadius: 4,
                        overflow: "hidden",
                        width: "23vw",

                        backgroundColor: "#f6f8fb",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                        <TableHead sx={{ backgroundColor: "#18234f" }}>
                          <TableRow>
                            <TableCell
                              sx={{ color: "white", fontWeight: "bold" }}
                            ></TableCell>
                            <TableCell
                              sx={{ color: "white", fontWeight: "bold" }}
                            >
                              Filtros
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ fontWeight: "bold" }}>
                              Buscar estudio:
                            </TableCell>
                            <TableCell>
                              <TextField
                                fullWidth
                                value={estudioBuscar}
                                disabled={viewOnly}
                                onChange={(e) => {
                                  setEstudioBuscar(e.target.value);
                                }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  },
                                }}
                                className="txfEspecialidad"
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "0.5vw",
                                }}
                              >
                                <IconButton
                                  onClick={handleMostrarTodos}
                                  sx={{ color: "#006787", fontSize: "1vw" }}
                                >
                                  <SearchIcon sx={{ fontSize: "1vw" }} />{" "}
                                  <Typography
                                    sx={{
                                      fontSize: "1vw",
                                    }}
                                  >
                                    Mostrar todos
                                  </Typography>
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ fontWeight: "bold" }}>
                              Ordenar estudios por:
                            </TableCell>
                            <TableCell>
                              <FormControl>
                                <RadioGroup
                                  row
                                  value={ordenarEstudios}
                                  onChange={(e) => {
                                    setOrdenarEstudios(e.target.value);
                                  }}
                                  disabled={viewOnly}
                                >
                                  <FormControlLabel
                                    sx={{
                                      "& .MuiFormControlLabel-label": {
                                        fontSize: "1vw",
                                        fontWeight: "bold",
                                      },
                                    }}
                                    value="codigo"
                                    control={
                                      <Radio
                                        disabled={viewOnly}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            height: "1vw",
                                            width: "1vw",
                                          },
                                        }}
                                      />
                                    }
                                    label="Codigo"
                                  />
                                  <FormControlLabel
                                    sx={{
                                      "& .MuiFormControlLabel-label": {
                                        fontSize: "1vw",
                                        fontWeight: "bold",
                                      },
                                    }}
                                    value="alfabeticamente"
                                    control={
                                      <Radio
                                        disabled={viewOnly}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            height: "1vw",
                                            width: "1vw",
                                          },
                                        }}
                                      />
                                    }
                                    label="Alfabeticamente"
                                  />
                                  <FormControlLabel
                                    sx={{
                                      "& .MuiFormControlLabel-label": {
                                        fontSize: "1vw",
                                        fontWeight: "bold",
                                      },
                                    }}
                                    value="area"
                                    control={
                                      <Radio
                                        disabled={viewOnly}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            height: "1vw",
                                            width: "1vw",
                                          },
                                        }}
                                      />
                                    }
                                    label="Area"
                                  />
                                  <FormControlLabel
                                    sx={{
                                      "& .MuiFormControlLabel-label": {
                                        fontSize: "1vw",
                                        fontWeight: "bold",
                                      },
                                    }}
                                    value="subrogados"
                                    control={
                                      <Radio
                                        disabled={viewOnly}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            height: "1vw",
                                            width: "1vw",
                                          },
                                        }}
                                      />
                                    }
                                    label="Subrogados"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ fontWeight: "bold" }}>
                              Mostrar por:
                            </TableCell>
                            <TableCell>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={mostrarSubrogados}
                                    onChange={(e) =>
                                      setMostrarSubrogados(e.target.checked)
                                    }
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "1vw",
                                      },
                                    }}
                                  />
                                }
                                label="Subrogados"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "1vw",
                                    fontWeight: "bold",
                                  },
                                }}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={mostrarNoSubrogados}
                                    onChange={(e) =>
                                      setMostrarNoSubrogados(e.target.checked)
                                    }
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "1vw",
                                      },
                                    }}
                                  />
                                }
                                label="No subrogados"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "1vw",
                                    fontWeight: "bold",
                                  },
                                }}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ fontWeight: "bold" }}>
                              Listas:
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "0.4vw",
                                }}
                              >
                                {listas.length > 0 ? (
                                  listas.map((l) => (
                                    <Box
                                      key={l.idListaPrecio}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "0.5vw",
                                        }}
                                      >
                                        <Checkbox
                                          checked={selectedListas.includes(l.idListaPrecio)}
                                          onChange={() => toggleSelectedLista(l.idListaPrecio)}
                                          sx={{
                                            padding: "0.2vw",
                                            '& .MuiSvgIcon-root': {
                                              fontSize: '1vw',
                                            },
                                          }}
                                        />
                                        <Box>
                                          <Typography
                                            sx={{
                                              fontSize: "0.9vw",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {l.nombre}
                                          </Typography>
                                          <Typography
                                            sx={{
                                              fontSize: "0.75vw",
                                              color: "#666",
                                            }}
                                          >
                                            ({l.descripcion || ""})
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <IconButton
                                        onClick={() =>
                                          handleDeleteLista(l.idListaPrecio)
                                        }
                                        sx={{ color: "red" }}
                                      >
                                        <DeleteIcon sx={{ fontSize: "1vw" }} />
                                      </IconButton>
                                    </Box>
                                  ))
                                ) : (
                                  <Typography sx={{ fontSize: "1vw" }}>
                                    No hay listas
                                  </Typography>
                                )}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "0.5vw",
                                  }}
                                >
                                  <IconButton
                                    onClick={handleCrearNuevaLista}
                                    sx={{ color: "#006787", fontSize: "1vw" }}
                                  >
                                    <PlaylistAddRoundedIcon
                                      sx={{ fontSize: "1vw" }}
                                    />
                                    <Typography
                                      sx={{
                                        fontSize: "1vw",
                                        marginLeft: "0.3vw",
                                      }}
                                    >
                                      Crear nueva lista
                                    </Typography>
                                  </IconButton>
                                </Box>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ fontWeight: "bold" }}>
                              Operaciones en precios sobre listas seleccionadas:
                            </TableCell>
                            <TableCell>
                              Redondear costo a numero entero:
                              <Select
                                input={<OutlinedInput />}
                                disabled={viewOnly}
                                value={redondearPrecios}
                                onChange={(e) => setRedondearPrecios(e.target.value)}
                                sx={{
                                  width: "12.51vw",
                                  maxWidth: "100%",

                                  height: "5vh",
                                  minHeight: "0px !important",
                                  overflow: "hidden",


                                  "&.MuiInputBase-root": {
                                    minHeight: "0px !important",
                                  },

                                  "& .MuiSelect-select": {
                                    minHeight: "0px !important",
                                    padding: "0 0.5vw !important",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "1vw",
                                    lineHeight: "1",
                                  },

                                  "& .MuiOutlinedInput-notchedOutline": {

                                    top: 0,
                                    "& legend": { display: "none" },
                                  },

                                  "& .MuiSvgIcon-root": {
                                    display: "inline-block !important",
                                    position: "absolute",
                                    right: "0.5vw",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "1.2vw !important",
                                    width: "1.2vw !important",
                                    height: "1.2vw !important",
                                    pointerEvents: "none",

                                  },
                                  minWidth: "0px !important",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                                className="selectOperaciones"
                              >
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="seleccione"
                                  disabled
                                >
                                  Seleccione
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="si"
                                >
                                  Si
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="no"
                                >
                                  No
                                </MenuItem>
                              </Select>
                              ¿Incrementar o Disminuir costo a estudios?:
                              <Select
                                input={<OutlinedInput />}
                                disabled={viewOnly}
                                value={bulkAction}
                                onChange={(e) => setBulkAction(e.target.value)}
                                sx={{
                                  width: "12.51vw",
                                  maxWidth: "100%",

                                  height: "5vh",
                                  minHeight: "0px !important",
                                  overflow: "hidden",


                                  "&.MuiInputBase-root": {
                                    minHeight: "0px !important",
                                  },

                                  "& .MuiSelect-select": {
                                    minHeight: "0px !important",
                                    padding: "0 0.5vw !important",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "1vw",
                                    lineHeight: "1",
                                  },

                                  "& .MuiOutlinedInput-notchedOutline": {

                                    top: 0,
                                    "& legend": { display: "none" },
                                  },

                                  "& .MuiSvgIcon-root": {
                                    display: "inline-block !important",
                                    position: "absolute",
                                    right: "0.5vw",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "1.2vw !important",
                                    width: "1.2vw !important",
                                    height: "1.2vw !important",
                                    pointerEvents: "none",

                                  },
                                  minWidth: "0px !important",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                                className="selectAoD"
                              >
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="seleccione"
                                  disabled
                                >
                                  Ninguna
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="aumentar"
                                >
                                  Aumentar
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="disminuir"
                                >
                                  Disminuir
                                </MenuItem>
                              </Select>
                              Monto:
                              <TextField
                                fullWidth
                                value={bulkAmount}
                                disabled={viewOnly}
                                onChange={(e) => {
                                  setBulkAmount(e.target.value);
                                }}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  },
                                }}
                                className="txfMonto"
                              />
                              ¿Cantidad o porcentaje?:
                              <Select
                                input={<OutlinedInput />}
                                disabled={viewOnly}
                                value={bulkType}
                                onChange={(e) => setBulkType(e.target.value)}
                                sx={{
                                  width: "12.51vw",
                                  maxWidth: "100%",

                                  height: "5vh",
                                  minHeight: "0px !important",
                                  overflow: "hidden",


                                  "&.MuiInputBase-root": {
                                    minHeight: "0px !important",
                                  },

                                  "& .MuiSelect-select": {
                                    minHeight: "0px !important",
                                    padding: "0 0.5vw !important",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "1vw",
                                    lineHeight: "1",
                                  },

                                  "& .MuiOutlinedInput-notchedOutline": {

                                    top: 0,
                                    "& legend": { display: "none" },
                                  },

                                  "& .MuiSvgIcon-root": {
                                    display: "inline-block !important",
                                    position: "absolute",
                                    right: "0.5vw",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "1.2vw !important",
                                    width: "1.2vw !important",
                                    height: "1.2vw !important",
                                    pointerEvents: "none",

                                  },
                                  minWidth: "0px !important",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                }}
                                className="selectAoD"
                              >
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="seleccione"
                                  disabled
                                >
                                  Ninguna
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="cantidad"
                                >
                                  Cantidad
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                  value="porcentaje"
                                >
                                  Porcentaje
                                </MenuItem>
                              </Select>
                              Aplicar para:
                              <br />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={bulkSubrogados}
                                    onChange={(e) => setBulkSubrogados(e.target.checked)}
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "1vw",
                                      },
                                    }}
                                  />
                                }
                                label="Subrogados"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "1vw",
                                    fontWeight: "bold",
                                  },
                                }}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={bulkNoSubrogados}
                                    onChange={(e) => setBulkNoSubrogados(e.target.checked)}
                                    sx={{
                                      "& .MuiSvgIcon-root": {
                                        fontSize: "1vw",
                                      },
                                    }}
                                  />
                                }
                                label="No subrogados"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "1vw",
                                    fontWeight: "bold",
                                  },
                                }}
                              />
                              <Box sx={{ display: "flex", justifyContent: "center", marginTop: "1vw" }}>
                                <Button
                                  variant="contained"
                                  onClick={handleApplyBulkOperation}
                                  disabled={
                                    bulkAction === "seleccione" ||
                                    bulkType === "seleccione" ||
                                    !bulkAmount ||
                                    parseFloat(bulkAmount) <= 0 ||
                                    isNaN(parseFloat(bulkAmount)) ||
                                    selectedListas.length === 0 ||
                                    (!bulkSubrogados && !bulkNoSubrogados)
                                  }
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw 1vw",
                                    backgroundColor: "#006787",
                                    color: "white",
                                    "&:hover": {
                                      backgroundColor: "#014e65",
                                    },
                                    "&.Mui-disabled": {
                                      backgroundColor: "#ccc",
                                      color: "#666",
                                    }
                                  }}
                                >
                                  Aplicar Cambios
                                </Button>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ fontWeight: "bold" }}>
                              Exportar en Excel
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "0.5vw",
                                }}
                              >
                                <IconButton
                                  onClick={handleExportarExcel}
                                  sx={{ color: "#006787", fontSize: "1vw" }}
                                >
                                  <Icon
                                    path={mdiFileExcel}
                                    size={1}
                                    color="green"
                                  />
                                  Listas Precios
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                    <Box
                      sx={{
                        width: "58vw",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: 3,
                        border: "1px solid #e0e0e0",
                        backgroundColor: "#ffffff",
                        overflow: "hidden",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          backgroundColor: "#f8fafc",
                          borderBottom: "1px solid #e2e8f0",
                          px: 2,
                          py: 0.5,
                        }}
                      >
                        <Typography sx={{ fontSize: "0.85rem", color: "#475569", fontWeight: 600 }}>
                          Estudios: <strong>{estudiosOrdenados.length}</strong>
                        </Typography>
                        <TablePagination
                          component="div"
                          count={estudiosOrdenados.length}
                          page={page}
                          onPageChange={handlePageChange}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleRowsPerPageChange}
                          rowsPerPageOptions={[20, 50, 100]}
                          labelRowsPerPage="Filas por página:"
                          labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`}
                          sx={{
                            "& .MuiTablePagination-toolbar": { minHeight: "38px", p: 0 },
                            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": { fontSize: "0.82rem", m: 0 },
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          overflowX: "auto",
                          overflowY: "auto",
                          maxHeight: "68vh",
                          backgroundColor: "#f6f8fb",
                          display: "block",
                        }}
                      >
                        <Table sx={{ backgroundColor: "white", minWidth: "max-content", width: "max-content", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                          <TableHead
                            stickyHeader
                            sx={{
                              backgroundColor: "#18234f",
                              position: "sticky",
                              top: 0,
                              zIndex: 2,
                            }}
                          >
                            <TableRow>
                              <TableCell
                                sx={{ color: "white", fontWeight: "bold" }}
                              >
                                Codigo
                              </TableCell>
                              <TableCell
                                sx={{ color: "white", fontWeight: "bold" }}
                              >
                                Estudio
                              </TableCell>
                              <TableCell
                                sx={{ color: "white", fontWeight: "bold" }}
                              >
                                Eliminar
                              </TableCell>
                              {activeListas.map((l) => (
                                <TableCell
                                  key={l.idListaPrecio}
                                  sx={{ color: "white", fontWeight: "bold" }}
                                >
                                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.2vw" }}>
                                    <Typography sx={{ color: "white", fontWeight: "bold", fontSize: "0.9vw" }}>
                                      Lista
                                    </Typography>
                                    <Typography sx={{ color: "white", fontSize: "1vw" }}>
                                      "{l.abreviatura || l.abr || l.nombre}"
                                    </Typography>
                                  </Box>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {loading ? (
                              <TableRow>
                                <TableCell
                                  colSpan={3 + activeListas.length}
                                  align="center"
                                  sx={{ py: 6 }}
                                >
                                  <CircularProgress sx={{ color: "#006787" }} />
                                  <Typography sx={{ mt: 2, fontSize: "1vw", color: "#006787", fontWeight: "bold" }}>
                                    Cargando precios y estudios...
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ) : estudiosOrdenados.length > 0 ? (
                              estudiosPaginados.map((estudio) => (
                                <TableRow key={estudio.idEstudio}>
                                  <TableCell>{estudio.codigo}</TableCell>
                                  <TableCell>
                                    <div style={{ whiteSpace: "pre-line" }}>
                                      {estudio.nombre}
                                      {!estudio.subrogado &&
                                        !estudio.esSubrogado &&
                                        (estudio.costoIntPrueba !== undefined &&
                                          estudio.costoIntPrueba !== null &&
                                          String(estudio.costoIntPrueba).trim() !== "") &&
                                        ` ($${estudio.costoIntPrueba})`}
                                      {estudio.subrogado && <strong>(subrogado)</strong>}
                                      {estudio.tipoMuestra && <strong>({estudio.tipoMuestra})</strong>}
                                      {estudio.subrogado && (
                                        <>
                                          {"\n---> "}
                                          {estudio.laboratorioAbreviatura || ""}
                                          {" ($"}
                                          {estudio.precioSubrogado || 0}
                                          {")"}
                                        </>
                                      )}
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      onClick={() =>
                                        handleResetPreciosEstudio(estudio.idEstudio, estudio.nombre)
                                      }
                                      sx={{ color: "red" }}
                                    >
                                      <DeleteIcon sx={{ fontSize: "1.5vw" }} />
                                    </IconButton>
                                  </TableCell>
                                  {activeListas.map((l) => (
                                    <TableCell
                                      key={`${estudio.idEstudio}-${l.idListaPrecio}`}
                                    >
                                      <TextField
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            width: "5vw",
                                            height: "5vh",
                                          },
                                          "& .MuiInputBase-input": {
                                            fontSize: "1vw",
                                            padding: "0.5vw",
                                          },
                                        }}
                                        value={
                                          preciosByLista[l.idListaPrecio] &&
                                            preciosByLista[l.idListaPrecio][
                                            estudio.idEstudio
                                            ] !== undefined
                                            ? preciosByLista[l.idListaPrecio][
                                            estudio.idEstudio
                                            ]
                                            : ""
                                        }
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          setPreciosByLista((prev) => {
                                            const next = { ...prev };
                                            if (!next[l.idListaPrecio])
                                              next[l.idListaPrecio] = {};
                                            next[l.idListaPrecio] = {
                                              ...next[l.idListaPrecio],
                                              [estudio.idEstudio]: val,
                                            };
                                            return next;
                                          });
                                        }}
                                        onBlur={(e) =>
                                          handleSavePrecio(
                                            l.idListaPrecio,
                                            estudio.idEstudio,
                                            e.target.value,
                                          )
                                        }
                                        className={highlighted[`${l.idListaPrecio}-${estudio.idEstudio}`] ? "input-verde" : ""}
                                      />
                                    </TableCell>
                                  ))}
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell
                                  colSpan={3 + activeListas.length}
                                  align="center"
                                  sx={{ py: 4 }}
                                >
                                  No hay registros
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          backgroundColor: "#f8fafc",
                          borderTop: "1px solid #e2e8f0",
                          px: 2,
                          py: 0.5,
                        }}
                      >
                        <TablePagination
                          component="div"
                          count={estudiosOrdenados.length}
                          page={page}
                          onPageChange={handlePageChange}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleRowsPerPageChange}
                          rowsPerPageOptions={[20, 50, 100]}
                          labelRowsPerPage="Filas por página:"
                          labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`}
                          sx={{
                            "& .MuiTablePagination-toolbar": { minHeight: "38px", p: 0 },
                            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": { fontSize: "0.82rem", m: 0 },
                          }}
                        />
                      </Box>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
          </Stack>
        </Box>
      </Content>
    </Layout>
  );
};
export default ListasPrecios;
